import { PricingPlansIcon, CheckBoxIcon } from "./Icons";
import styles from "./UpgradePlan.module.scss";
import { FormattedMessage } from "react-intl";
import { useSelector } from "redux/hooks";

export const UpgradePlanInfo = () => {
  const { userDetail } = useSelector((state) => state.authReducer);
  const activeSubscription = userDetail?.user?.activeSubscription?.name || "Free";

//   Default to Solo plan info
  let planId = "deftgpt.plan.solo";
  let planPrice = "$9.99";
  let planPoints = [
    "deftgpt.plan.solo.point1",
    "deftgpt.plan.solo.point2",
    "deftgpt.plan.solo.point3",
    "deftgpt.plan.point4",
  ];

  // Set plan info based on subscription
  switch (activeSubscription) {
    case "Free":
      planId = "deftgpt.plan.solo";
      planPrice = "$9.99";
      planPoints = [
        "deftgpt.plan.solo.point1",
        "deftgpt.plan.solo.point2",
        "deftgpt.plan.solo.point3",
        "deftgpt.plan.point4",
      ];
      break;
    case "Standard":
      planId = "deftgpt.plan.pro";
      planPrice = "$19.99"; 
      planPoints = [
        "deftgpt.plan.pro.point1",
        "deftgpt.plan.pro.point2",
        "deftgpt.plan.pro.point3",
        "deftgpt.plan.point4",
      ];
      break;
    case "Professional":
      planId = "deftgpt.plan.team";
      planPrice = "$69.99"; 
      planPoints = [
        "deftgpt.plan.team.point1",
        "deftgpt.plan.team.point2",
        "deftgpt.plan.team.point3",
        "deftgpt.plan.point4",
      ];
      break;
    case "Team":
      planId = "deftgpt.plan.enterprise";
      planPrice = "$259.99";
      planPoints = [
        "deftgpt.plan.enterprise.point1",
        "deftgpt.plan.enterprise.point2",
        "deftgpt.plan.enterprise.point3",
        "deftgpt.plan.point4",
      ];
      break;
    default:
      // Keep default Solo plan
      break;
  }

  return (
    <div className={styles.planBox}>
      <div className="flex justify-between w-full">
        <div className="flex gap-[8px] items-center">
          <div className="flex-shrink-0 leading-[0]"><PricingPlansIcon /></div>
          <div className={styles.planName}>
            <FormattedMessage id={planId} />
          </div>
        </div>
        <div className="flex flex-col items-end ">
          <div className={styles.planPrice}>{planPrice}</div>
          <div className={styles.month}>/<FormattedMessage id="settings.plan.feature.3.month" /></div>
        </div>
      </div>
      <ul className="flex gap-[8px] flex-col">
        {planPoints.map((id) => (
          <li key={id} className={styles.features}>
            <span className="flex-shrink-0 leading-[0]"><CheckBoxIcon /></span>
            <span className={styles.statements}>
            <FormattedMessage
              id={id}
              values={{
                highlighted: (chunks) => (
                  <span className={styles.highlightedTxt}>{chunks}</span>
                ),
              }}
            />
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};